            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
            <validation-observer v-slot="{ invalid }"> 
                  <b-form  inline style="margin-bottom:15px;" novalidate >

                    <b-row style="width:100%;padding-top:20px;padding-bottom:20px;">
                      <b-col :md="6">
                        <span style="font-weight:500">Paciente:</span> {{dataForm[namePath].datos_pacientes.name}}
                      </b-col>
                      <b-col :md="6">
                        <span style="font-weight:500">Ultimo exámen:</span> 
                      </b-col>
                      <b-col :md="6">
                        <span style="font-weight:500">Documento:</span>  {{dataForm[namePath].datos_pacientes.documento}}
                      </b-col>
                      <b-col :md="6">
                        <span style="font-weight:500">Motivo consulta:</span> <b-form-input style="width: auto !important;margin-bottom: 0;" v-model="dataForm[namePath].info_agendas.evaluacion"></b-form-input> 
                      </b-col>
                      <b-col :md="6">
                        <span style="font-weight:500">Edad:</span> {{dataForm[namePath].datos_pacientes.edad}} años
                      </b-col>
                      <b-col :md="6">
                        <span style="font-weight:500">Profesión:</span> {{dataForm[namePath].datos_pacientes.cargo}}
                      </b-col>
                    </b-row>
  
                    <b-row style="width:100%">
                      <b-col>
                          <br>
                          <b-nav tabs justified>
                            <b-nav-item @click="active=0" :active="active===0">Datos</b-nav-item>
                            <b-nav-item @click="active=1" :active="active===1">Antecedentes</b-nav-item>
                            <b-nav-item @click="active=2" :active="active===2">Pruebas</b-nav-item>
                            <b-nav-item @click="active=3" :active="active===3">Agudeza Visual</b-nav-item>
                            <b-nav-item @click="active=4" :active="active===4">Diagnostico</b-nav-item>
                          </b-nav>
                      </b-col>
                      <b-col :md="12" v-if="active===0">  
                        <b-row class="row-inputs"  style="border: 1px solid #dee2e6;border-top: none;padding:20px;">
                          <sw-inputs
                            inputTabla="datos_pacientes"
                            inputCampo="id_list_tipo">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="datos_pacientes"
                            inputCampo="documento">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="datos_pacientes"
                            inputCampo="name"
                            :md="12"
                            :lg="6">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="datos_pacientes"
                            inputCampo="edad">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="datos_pacientes"
                            inputCampo="id_list_genero">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="datos_pacientes"
                            inputCampo="direccion"
                            :md="12"
                            :lg="6">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="datos_pacientes"
                            inputCampo="ciudad">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="datos_pacientes"
                            inputCampo="telefonos">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="datos_pacientes"
                            inputCampo="email"
                            :md="12"
                            :lg="6">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="datos_pacientes"
                            inputCampo="empresa"
                            :lg="6">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="datos_pacientes"
                            inputCampo="cargo"
                            :lg="6">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="datos_pacientes"
                            inputCampo="id_list_eps"
                            :lg="6">
                          </sw-inputs>                           
                        </b-row>
                      </b-col> 
                      <b-col  :md="12"  v-if="active===1">
                        <b-row  style="border: 1px solid #dee2e6;border-top: none;padding:20px;">
                          <sw-inputs
                            inputTabla="examen_antecedentes"
                            inputCampo="descripcion"
                            :md="12"
                            :lg="12">
                          </sw-inputs>
                        </b-row>                      
                      </b-col> 
                      <b-col :md="12" v-if="active===2"> 
                        <b-row class="row-inputs"  style="border: 1px solid #dee2e6;border-top: none;padding:20px;">
                          <b-col :md="6"> 
                            <h5 class="title-form  subtitle-form" style="margin-top:10px;margin-bottom:0">Examen externo</h5>
                            <b-row class="row-inputs">
                              <sw-inputs
                                inputTabla="examen_pruebas"
                                inputCampo="ojo_derecho"
                                :md="12"
                                :lg="12">
                              </sw-inputs>
                              <sw-inputs
                                inputTabla="examen_pruebas"
                                inputCampo="ojo_izquierdo"
                                :md="12"
                                :lg="12">
                              </sw-inputs>
                            </b-row>
                          </b-col>
                          <b-col :md="6"> 
                            <h5 class="title-form  subtitle-form" style="margin-top:10px;margin-bottom:0">Cover Test</h5>
                            <b-row>
                              <sw-inputs
                                inputTabla="examen_pruebas"
                                inputCampo="vision_lejana"
                                :md="12"
                                :lg="12">
                              </sw-inputs>
                              <sw-inputs
                                inputTabla="examen_pruebas"
                                inputCampo="vision_proxima"
                                :md="12"
                                :lg="12">
                              </sw-inputs>
                            </b-row>
                          </b-col>
                          <b-col :md="6"> 
                            <h5 class="title-form  subtitle-form" style="margin-top:10px;margin-bottom:0">Reflejos</h5>
                            <b-row>
                              <sw-inputs
                                inputTabla="examen_pruebas"
                                inputCampo="observacion"
                              :md="12"
                                :lg="12">
                              </sw-inputs>
                            </b-row>
                          </b-col>
                          <b-col :md="6"> 
                            <h5 class="title-form  subtitle-form" style="margin-top:10px;margin-bottom:0">Motilidad Ocular</h5>
                            <b-row>
                              <sw-inputs
                                inputTabla="examen_pruebas"
                                inputCampo="obser_1"
                              :md="12"
                                :lg="12">
                              </sw-inputs>
                            </b-row>
                          </b-col>  
                          <b-col :md="12"> 
                            <h5 class="title-form  subtitle-form" style="margin-top:10px;margin-bottom:0">Punto Proximo De Convergencia</h5>
                            <b-row>
                               <sw-inputs
                                inputTabla="examen_pruebas"
                                inputCampo="obser_2"
                                :md="12"
                                :lg="12">
                              </sw-inputs>
                            </b-row>
                          </b-col>                       
                          <b-col :md="6"> 
                            <h5 class="title-form  subtitle-form" style="margin-top:10px;margin-bottom:0">Oftalmoscopia</h5>
                            <b-row>
                              <sw-inputs
                                inputTabla="examen_pruebas"
                                inputCampo="ojo_derecho1"
                                :md="12"
                                :lg="12">
                              </sw-inputs>
                              <sw-inputs
                                inputTabla="examen_pruebas"
                                inputCampo="ojo_izquierdo1"
                                :md="12"
                                :lg="12">
                              </sw-inputs>
                            </b-row>
                          </b-col>
                          <b-col :md="6"> 
                            <h5 class="title-form  subtitle-form" style="margin-top:10px;margin-bottom:0">Queratrometria</h5>
                            <b-row>
                              <sw-inputs
                                inputTabla="examen_pruebas"
                                inputCampo="ojo_derecho2"
                                :md="12"
                                :lg="12">
                              </sw-inputs>
                              <sw-inputs
                                inputTabla="examen_pruebas"
                                inputCampo="ojo_izquierdo2"
                                :md="12"
                                :lg="12">
                              </sw-inputs>
                            </b-row>
                          </b-col>
                          <b-col :md="6"> 
                            <h5 class="title-form  subtitle-form" style="margin-top:10px;margin-bottom:0">Refraccion</h5>
                            <b-row>
                              <sw-inputs
                                inputTabla="examen_pruebas"
                                inputCampo="ojo_derecho3"
                                :md="12"
                                :lg="12">
                              </sw-inputs>
                              <sw-inputs
                                inputTabla="examen_pruebas"
                                inputCampo="ojo_izquierdo3"
                                :md="12"
                                :lg="12">
                              </sw-inputs>
                            </b-row>
                          </b-col>
                          <b-col :md="6"> 
                            <h5 class="title-form  subtitle-form" style="margin-top:10px;margin-bottom:0">RX Final</h5>
                            <b-row>
                              <sw-inputs
                                inputTabla="examen_pruebas"
                                inputCampo="ojo_derecho4"
                                :md="12"
                                :lg="12">
                              </sw-inputs>
                              <sw-inputs
                                inputTabla="examen_pruebas"
                                inputCampo="ojo_izquierdo4"
                                :md="12"
                                :lg="12">
                              </sw-inputs>                              
                            </b-row>
                          </b-col>
                          <b-col :md="12"> 
                            <h5 class="title-form  subtitle-form" style="margin-top:10px;margin-bottom:0">Vision Color</h5>
                          </b-col>
                          <sw-inputs
                            inputTabla="examen_pruebas"
                            inputCampo="ojo_derecho5"
                           :md="6"
                            :lg="6">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="examen_pruebas"
                            inputCampo="ojo_izquierdo5"
                           :md="6"
                            :lg="6">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="examen_pruebas"
                            inputCampo="ciclopejia"
                           :md="12"
                            :lg="12">
                          </sw-inputs>
                          <b-col :md="12"> 
                            <h5 class="title-form  subtitle-form" style="margin-top:10px;margin-bottom:0">Estereopsis</h5>
                          </b-col>
                          <sw-inputs
                            inputTabla="examen_pruebas"
                            inputCampo="obser_3"
                           :md="12"
                            :lg="12">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="examen_pruebas"
                            inputCampo="codigo"
                           :md="2"
                            :lg="2">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="examen_pruebas"
                            inputCampo="diagnostico"
                           :md="3"
                            :lg="3">
                          </sw-inputs>
                          <sw-inputs 
                            inputTabla="examen_pruebas"
                            inputCampo="ojo_diagnostico"
                           :md="2"
                            :lg="2">
                          </sw-inputs>
                          <sw-inputs 
                            inputTabla="examen_pruebas"
                            inputCampo="origen"
                           :md="2"
                            :lg="2">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="examen_pruebas"
                            inputCampo="tipo"
                            :md="3"
                            :lg="3">
                          </sw-inputs>
                          <b-col :md="12"> 
                            <h5 class="title-form  subtitle-form" style="margin-top:10px;margin-bottom:0">Conducta A Seguir</h5>
                          </b-col>
                          <sw-inputs
                            inputTabla="examen_pruebas"
                            inputCampo="conducta_a"
                           :md="12"
                            :lg="12">
                          </sw-inputs>
                          <b-col :md="12"> 
                            <h5 class="title-form  subtitle-form" style="margin-top:10px;margin-bottom:0">Otras Observaciones Y Recomendaciones</h5>
                          </b-col>
                          <sw-inputs
                            inputTabla="examen_pruebas"
                            inputCampo="otras_recomen"
                           :md="12"
                            :lg="12">
                          </sw-inputs>  
                          <b-col :md="12" class="text-right">
                            <b-button variant="white" class="btn-link" @click="active=3">Continuar </b-button>
                          </b-col>                         
                        </b-row>
                      </b-col> 
                      <b-col :md="12" v-if="active===3"> 
                        <b-row class="row-inputs" style="border: 1px solid #dee2e6;border-top: none;padding:20px;">                          
                          <b-col :md="12" :lg="12">
                            <table class="table" style="width:100%;margin-top:10px">
                              <thead class="thead-light text-center">
                                <tr>
                                  <th></th>
                                  <th>Sin Corrección</th>
                                  <th>AV/VL</th>                                  
                                  <th>AV/VP</th>
                                  <th>PH</th>   
                                  <th>RX Anterior</th>
                                  <th>AV/VL</th>                                  
                                  <th>AV/VP</th>
                                  <th>PH</th>                              
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td style="font-weight: bold">OD</td>
                                   <tr>
                                  <td style="font-weight: bold">OD</td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_pruebas.od_sinco"></b-form-input>
                                  </td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_pruebas.od_avvl"></b-form-input>
                                  </td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_pruebas.od_avvp"></b-form-input></td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_pruebas.od_ph"></b-form-input></td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_pruebas.od_rxant"></b-form-input>
                                    </td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_pruebas.od_avvl2"></b-form-input>
                                    </td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_pruebas.od_avvp2"></b-form-input>
                                    </td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_pruebas.od_ph2"></b-form-input>
                                    </td>
                                </tr>
                                <tr>
                                  <td  style="font-weight: bold">OI</td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_pruebas.oi_sinco"></b-form-input>
                                  </td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_pruebas.oi_avvl"></b-form-input>
                                  </td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_pruebas.oi_avvp"></b-form-input></td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_pruebas.oi_ph"></b-form-input></td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_pruebas.oi_rxant"></b-form-input>
                                    </td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_pruebas.oi_avvl2"></b-form-input>
                                    </td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_pruebas.oi_avvp2"></b-form-input>
                                    </td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_pruebas.oi_ph2"></b-form-input>
                                    </td>
                                </tr>                                
                              </tbody>
                            </table>
                          </b-col>              
                        </b-row>                               
                      </b-col>
                      <b-col :md="12" v-if="active===4"> 
                        <b-row class="row-inputs" style="border: 1px solid #dee2e6;border-top: none;padding:20px;">
                          <sw-inputs
                            inputTabla="examen_diagnosticos"
                            inputCampo="lente"
                           :md="6"
                            :lg="6">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="examen_diagnosticos"
                            inputCampo="uso"
                           :md="6"
                            :lg="6">
                          </sw-inputs>  
                          <sw-inputs
                            inputTabla="examen_diagnosticos"
                            inputCampo="observacion"
                           :md="12"
                            :lg="12">
                          </sw-inputs>
                          <b-col :md="12" :lg="12">
                            <table class="table" style="width:100%;margin-top:10px">
                              <thead class="thead-light text-center">
                                <tr>
                                  <th>RX</th>
                                  <th>ESF</th>
                                  <th>CIL</th>                                  
                                  <th>EJE</th>
                                  <th>ADD</th>
                                  <th>AV</th>
                                  <th>DP</th>                                
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td style="font-weight: bold">OD</td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_diagnosticos.od_esf"></b-form-input>
                                  </td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_diagnosticos.od_cil"></b-form-input>
                                  </td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_diagnosticos.od_eje"></b-form-input></td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_diagnosticos.od_add"></b-form-input></td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_diagnosticos.od_av"></b-form-input></td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_diagnosticos.od_dp"></b-form-input></td>
                                </tr>
                                <tr>
                                  <td  style="font-weight: bold">OI</td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_diagnosticos.oi_esf"></b-form-input>
                                  </td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_diagnosticos.oi_cil"></b-form-input>
                                  </td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_diagnosticos.oi_eje"></b-form-input></td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_diagnosticos.oi_add"></b-form-input></td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_diagnosticos.oi_av"></b-form-input></td>
                                  <td>
                                    <b-form-input v-model="dataForm[namePath].examen_diagnosticos.oi_dp"></b-form-input></td>
                                </tr>                                
                              </tbody>
                            </table>
                          </b-col> 
                          <sw-inputs
                            inputTabla="examen_diagnosticos"
                            inputCampo="conducta"
                           :md="12"
                            :lg="12">
                          </sw-inputs>          
                        </b-row>
                        <div>  
                            <footer class="modal-footer" style="margin: 15px -30px 0; padding-top: 10px;padding-bottom:0">                 
                              <sw-saveform
                                nameBtn="Exámen"
                                :invalid="invalid"
                                @save="save"
                                >
                              </sw-saveform>
                            </footer>          
                        </div>            
                      </b-col>                             
                    </b-row>                  
                  </b-form>   
            </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform        
  },
  props: {
  },
  data()
  {
    return {
      active: 1
    }
  },
  async created()
  {  
    if(this.namePath==='paciente_agenda')
    {
        var getList = this.gettersDatalist('datos_pacientes',this.dataGet[this.namePath].data[this.indexData].info_agendas.id_datos_pacientes) 
    }
    if(this.namePath==='paciente_historial')
    {
        var getList = this.gettersDatalist('datos_pacientes',this.dataGet[this.namePath].data[this.indexData].info_examens.id_datos_pacientes) 
        
       await this.updateDataForm({state: 'info_agendas', data: {evaluacion: ''}})
    }
      await this.updateDataForm({state: 'datos_pacientes', data: getList[0]})
      
      let dataKeys=Object.keys(this.dataGet[this.namePath].data[this.indexData])
      for (let i = 0; i < dataKeys.length; i++) {
        await this.updateDataForm({state: dataKeys[i],data: this.dataGet[this.namePath].data[this.indexData][dataKeys[i]] }) 
      } 
      console.log(this.dataGet[this.namePath].data[this.indexData],this.dataForm[this.namePath])
  },
  async beforeDestroy()
  {
    await this.resetGlobal({state: 'indexData'})
    await this.resetDataForm()
  },
  computed: { 
  },
  methods: {
    save(event)
    {
      this.$emit('save',{save: false, ftn: 'pacienteExamenFtn' })
    }
  }
}
</script>
<style>
</style>